import { SchaefflerCADFileSearchComponent } from "~/features/CADSearch/SchaefflerCADFileSearchComponent";
import type ComponentTypes from "~/features/cms/componentTypes";

/**
 * CMS wrapper for the {@code SchaefflerCADFileSearchComponent}.
 *
 * <p>The BFF transformer ({@code SchaefflerCADFileSearchComponentTransformer}) emits only the
 * component id — the actual CAD search UI is a self-fetching React island
 * ({@link SchaefflerCADFileSearchComponent}) that the legacy JSP mounted proplessly via
 * {@code createComponentAtId}. The id is therefore intentionally ignored here; the island owns its
 * data and rendering, mirroring the pre-shell JSP behavior.
 */
export interface CMSCadFileSearchProps {
  type: ComponentTypes.CMSCadFileSearch;
  id?: string;
  className?: string;
}

export const CMSCadFileSearch = (_props: CMSCadFileSearchProps) => {
  return <SchaefflerCADFileSearchComponent />;
};
